import { Box, Divider } from '@chakra-ui/react';
import { addDays } from 'date-fns';
import pt from 'date-fns/locale/pt';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { DateRange, RangeKeyDict } from 'react-date-range';

import { setDateToTheEndOfTheDay } from '../../utils/date.util';

type TesteProps = {
  isOpenDatePicker?: boolean;
  setIsOpenDatePicker?: any;
  setIsChosenDate?: any;
  startDate: string;
  setStartDate: any;
  endDate: string;
  setEndDate: any;
};

export const DatePickerRangerUnlimited = ({
  setIsOpenDatePicker,
  setIsChosenDate,
  startDate = new Date().toISOString(),
  setStartDate,
  endDate = addDays(new Date(), 7).toISOString(),
  setEndDate
}: TesteProps) => {
  const [dateState, setDateState] = useState<any>([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: 'selection'
    }
  ]);
  const handleSetDate = (item: RangeKeyDict) => {
    setDateState([
      {
        startDate: item.selection.startDate,
        endDate: item.selection.endDate,
        key: 'selection'
      }
    ]);
    setStartDate(item.selection.startDate?.toISOString());
    setEndDate(setDateToTheEndOfTheDay(item.selection.endDate)?.toISOString());
    console.log(
      'datas selecionadas',
      item.selection.startDate?.toISOString(),
      item.selection.endDate?.toISOString()
    );
    if (item.selection.startDate != item.selection.endDate) {
      setIsOpenDatePicker(false);
      setIsChosenDate(true);
    }
  };

  return (
    <Box
      data-testid="element-datapicker"
      maxW="fit-content"
      width="fit-content"
      backgroundColor="#fff"
      margin="0 auto"
      position="absolute"
      left="250px"
      top="250px"
    >
      <DateRange
        onChange={(item) => handleSetDate(item)}
        ranges={dateState}
        showDateDisplay={false}
        monthDisplayFormat="MMMM yyyy"
        showMonthAndYearPickers={false}
        weekdayDisplayFormat="EEEEE"
        months={2}
        locale={pt}
        direction="horizontal"
      />
    </Box>
  );
};
